<template>
  <span>
    <i class="material-icons pointer" @click="emailTask(task)">email</i>
  </span>
</template>

<script>
import api from "api";

export default {
  props: {
    task: {
      type: Object
    }
  },
  methods: {
    emailTask(task){
      if(confirm("Are you sure you want to email this task to yourself?")){
        api.emailTask(this.task.id).then(response => {

        });
      };
    }
  }
}
</script>
